import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@rtkwlf/pro-regular-svg-icons/faRotateLeft';
import { faExclamationTriangle } from '@rtkwlf/pro-solid-svg-icons/faExclamationTriangle';
import { type FallbackProps } from 'react-error-boundary';

import { Button } from '@packages/fenrir/components';

import { Empty } from '../../components/empty/empty';
import { useSecurityJourneyTranslations } from '../../locales/use-security-journey-translations';

import styles from './error.module.css';

export const SpidrLibraryPageErrorBoundary = ({
  resetErrorBoundary,
}: FallbackProps) => {
  /**
   * get an instance of the translations
   */
  const { t } = useSecurityJourneyTranslations();

  return (
    <div className={styles['spidr-library-error']}>
      <Empty
        icon={faExclamationTriangle}
        heading={t('spidrLibrary.errorHeading')}
        message={t('spidrLibrary.errorMessage')}
      >
        <Button
          startIcon={<FontAwesomeIcon icon={faRotateLeft} />}
          onClick={resetErrorBoundary}
          variant="contained"
        >
          {t('common.retry')}
        </Button>
      </Empty>
    </div>
  );
};
